export { default as UiTab } from "./UiTab";
